


import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button,
    Box,
    Typography,
    Grid,
    Divider,
} from "@mui/material";
import { CancelSharp, Close as CloseIcon, Description } from "@mui/icons-material";
import { Formik, Form, useFormikContext } from "formik";

import { FaPlus } from "react-icons/fa6";
import { MdPayment } from "react-icons/md";

import './EditProfileModal.css'; // Import external CSS
// import "../../../../Components/ModalCss/BannerinputGetModal.css";

import { MdCancel } from "react-icons/md";
import * as Yup from "yup";
import CustomInputLogin from "../../../Components/CustomInputLogin/CustomInputLogin";
import CustoDropDownRegister from "../../../Components/CustomDropDown/CustoDropDownRegister";
import CustomDateInput from "../../../Components/CustomDate/CustomDateInput";
import { toast, ToastContainer } from "react-toastify";
import actions from "../../../ReduxStore/actions";
import { useDispatch, useSelector } from "react-redux";
import FileUploadComponent from "../../../Components/FileUploadComponent/FileUploadComponent";
import { updateAwardAction } from "../../../ReduxStore/Slices/EditProfile/updateAward";
import CustomRadioButton from "../../../Components/CustomRadioButton/CustomRadioButton";
import CustomFromAndToDate from "../../../Components/CustomFromAndToDate/CustomFromAndToDate";
import CustomIsCurrentorNotFromToDate from "../../../Components/CustomFromAndToDate/CustomIsCurrentorNotFromToDate";
import CustomAddMultipleInputs from "../../../Components/CustomInputLogin/CustomAddMultipleInputs";
const validationSchema = Yup.object().shape({
    project_title: Yup.string().required("Project title is required"),
    role: Yup.string().required("Role is required"),
    isCurrent: Yup.string().oneOf(["yes", "no"]).required("Current status is required"),
    fromDate: Yup.date()
        .required("From Date is required")
        .typeError("Invalid date format"),
    toDate: Yup.date()
        .nullable()
        .when("isCurrent", {
            is: "no",
            then: (schema) =>
                schema
                    .required("To Date is required")
                    .typeError("Invalid date format")
                    .min(Yup.ref("fromDate"), "To Date cannot be before From Date"),
            otherwise: (schema) => schema.notRequired().nullable(),
        }),
});
const ProjectsCreateModal = ({
    open,
    onClose,
    setSubmittedValues,
    submittedValues,
    projectEditData,
    setProjectEditData,
    uploadedFile,
    setUploadedFile
}) => {
    console.log(uploadedFile, "uploadedFile")
    const dispatch = useDispatch()
    const { createEducation } = useSelector(state => state?.createEducation);
    const { updateEducation } = useSelector(state => state?.updateEducation);
    const [inputValue, setInputValue] = useState("");
    const [localValues, setLocalValues] = useState([]);

    console.log(projectEditData, "projectEditData")



    useEffect(() => {
        setLocalValues(projectEditData?.skills)
    }, [projectEditData?.project_id]);

    const sessionUserId = sessionStorage.getItem("userId")
    const handleCrate = async (values, { resetForm }) => {

        if (!projectEditData?.project_id) {
            const data1 = {
                data: {
                    user_id: sessionUserId,
                    project_title: values?.project_title,
                    role: values?.role,
                    start_date: values?.fromDate,
                    end_date: values?.toDate,
                    location: values?.location,
                    skills: values?.skills,
                    description: values?.description,
                    isOngoing: values?.isCurrent === "yes" ? true : false,
                    certificate_file: values?.file1
                },
                method: "post",
                apiName: `createProject`,
            };
            const response = await dispatch(actions.CREATEPROJECT(data1));
            console.log(response, "responsedataaaaaaa")
            if (response?.payload?.message === "Project created successfully.") {
                toast?.success('Project created successfully.')
                setTimeout(() => {
                    onClose()
                    resetForm()
                    setUploadedFile(null)
                }, 1500)
            } else {
                toast.error(response?.payload?.message)
            }
        } else {
            const data1 = {
                data: {
                    project_title: values?.project_title,
                    role: values?.role,
                    start_date: values?.fromDate,
                    end_date: values?.toDate,
                    location: values?.location,
                    skills: values?.skills,
                    description: values?.description,
                    isOngoing: values?.isCurrent === "yes" ? true : false,
                    certificate_file: values?.file1
                },
                method: "put",
                apiName: `updateProject/${projectEditData?.project_id}`,
            };
            const response = await dispatch(actions.UPDATEPROJECT(data1));
            console.log(response, "responsedataaaaaaa")
            if (response?.payload?.message === "Project updated successfully.") {
                toast?.success('Project updated successfully.')
                setTimeout(() => {
                    onClose()
                    resetForm()
                    setUploadedFile(null)
                    setProjectEditData(null)
                }, 1500)
            } else {
                toast.error(response?.payload?.message)
            }

        }


    }


    // useEffect(() => {

    //     if (awardEditId !== null) {

    //         const fetchData = async () => {
    //             const data1 = {
    //                 data: {},
    //                 method: "get",
    //                 apiName: `getAwardById/${awardEditId}`,
    //             };
    //             const response = await dispatch(actions.GETAWARDBYID(data1));
    //         }
    //         fetchData()
    //     }

    // }, [awardEditId]);



    return (
        <Dialog
            open={open}
            onClose={() => {
                onClose()
                setProjectEditData(null)
                setUploadedFile(null)

            }
            }
            fullWidth
            maxWidth="md"
            className="custom-dialog"
            sx={{
                maxWidth: "700px",
                margin: "auto",
                "& .MuiPaper-root": {
                    borderRadius: "14px", // Target the Paper component
                },
            }}
        >
            <Box sx={{ position: "relative" }}>
                <Box className="dialog-heading">
                    <IconButton
                        aria-label="Close"
                        onClick={() => {
                            onClose()
                            setProjectEditData(null)
                            setUploadedFile(null)

                        }}
                        sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            color: 'white',
                        }}
                    >
                        <MdCancel />
                    </IconButton>
                    <DialogTitle className="custom-dialog-title">
                        <Box>
                            <Typography variant="subtitle1" sx={{ color: "white" }}>

                                {projectEditData ? "Edit Projects" : "Add Projects"}
                            </Typography>
                        </Box>
                    </DialogTitle>
                </Box>
                <DialogContent sx={{ overflowY: "scroll", height: "400px" }}>
                    {/* <Box sx={{ position: "absolute", right: "10px", top: 5 }}>
                        <CancelSharp
                            style={{ display: { sx: "none", md: "block" } }}
                            // onClick={() => {
                            //     navigate("/")
                            // }}
                        />
                    </Box> */}
                    <Grid
                        item
                        size={{ md: 5, xs: 12 }}


                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            // p: 2,
                            background: '#FFFFFF',
                            width: '100%',

                        }}
                    >

                        <Box sx={{
                            // display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                            // boxShadow: { xs: 0, sm: 4, md: 4 },
                            padding: { xs: 0, sm: 1, md: 2 },
                            width: "100%",
                            // boxShadow: 4,
                            // m: 4


                            // border: "1px solid red"
                        }}>


                            <Formik
                                enableReinitialize
                                initialValues={{

                                    description: projectEditData?.description || "",
                                    project_title: projectEditData?.project_title || "",


                                    isCurrent: projectEditData?.isOngoing === true ? "yes" : "no" || "yes",
                                    fromDate: projectEditData?.start_date || null,
                                    toDate: projectEditData?.end_date || null,
                                    file1: projectEditData?.certificate_file || null,
                                    role: projectEditData?.role || '',
                                    industry_category: projectEditData?.industry_category || "",
                                    skills: "",





                                }}
                                validationSchema={validationSchema}
                                onSubmit={handleCrate}
                            >
                                {({ handleSubmit, resetForm, setFieldValue, values }) => (

                                    <Form onSubmit={handleSubmit}>
                                        < Grid container columnSpacing={4} rowSpacing={2}>
                                            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
                                                <CustomInputLogin
                                                    name="project_title"
                                                    label="Project title"
                                                    inputType="text"
                                                    custPlaceholder="Enter your project title"
                                                    important={true}
                                                />
                                            </Grid>



                                            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
                                                <CustomInputLogin
                                                    name="role"
                                                    label="Role"
                                                    inputType="text"
                                                    custPlaceholder="Enter your role"
                                                    important={true}
                                                />
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
                                                <CustomRadioButton
                                                    label="Currently Ongiong"
                                                    name="isCurrent"
                                                    value={values.isCurrent}
                                                    onChange={(val) => setFieldValue("isCurrent", val)}
                                                    options={[
                                                        { value: "yes", label: "Yes" },
                                                        { value: "no", label: "No" },
                                                    ]}
                                                />
                                            </Grid>

                                            {/* <Grid item xs={12} md={6}> */}

                                            {/* <CustomIsCurrentorNotFromToDate
                                                label1="From Date"
                                                label2="To Date"
                                                showToDate={values.isCurrent === "no"} // Only show To Date if not currently studying
                                            /> */}
                                            <CustomIsCurrentorNotFromToDate
                                                label1="From Date"
                                                label2="To Date"
                                                important={true}

                                                showToDate={values.isCurrent === "no"} // Only show To Date if not currently studying
                                            />
                                            {/* </Grid> */}


                                            {/* <Grid size={{ xs: 12, md: 6, sm: 6 }}>
                                                <CustomDateInput
                                                    name="start_date"
                                                    label="Start Date"
                                                    custPlaceholder="Enter your start date"

                                                />

                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
                                                <CustomDateInput
                                                    name="end_date"
                                                    label="End Date"
                                                    custPlaceholder="Enter your end date"

                                                />

                                            </Grid> */}
                                            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
                                                <CustomAddMultipleInputs
                                                    label="Skills"
                                                    name="skills"
                                                    inputType="text"
                                                    custPlaceholder="Enter skills used"
                                                    setFieldValue={setFieldValue}
                                                    values={values?.skills}
                                                    inputValue={inputValue} // Pass inputValue
                                                    setInputValue={setInputValue} //
                                                    localValues={localValues}
                                                    setLocalValues={setLocalValues}

                                                />
                                            </Grid>


                                            <Grid size={{ md: 6, xs: 12, sm: 6 }}>
                                                <FileUploadComponent
                                                    name="file1"
                                                    uploadedFile={uploadedFile}
                                                    setUploadedFile={setUploadedFile}
                                                    onFileUpload={(file) => setFieldValue("file1", file)}
                                                />
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 12, sm: 12 }}>
                                                <CustomInputLogin
                                                    name="description"
                                                    label="Description"
                                                    inputType="textarea"
                                                    custPlaceholder="Enter your description"
                                                />
                                            </Grid>


                                            <Grid size={{ xs: 12 }} sx={{ display: "flex", justifyContent: "end" }}>
                                                <Button
                                                    variant="contained"
                                                    type="submit"
                                                    // onClick={handleGoRegisterComplete}
                                                    // sx={{ textTransform: "none", background: "#C38F51", color: "white", borderRadius: "23px" }}
                                                    sx={{
                                                        // backgroundColor: "#C38F51",
                                                        textTransform: "none",
                                                        color: "white",
                                                        fontSize: "16px",
                                                        mr: 2,
                                                        // padding: "0px 40px",
                                                        padding: { xs: "0px 20px", md: "0px 40px" },

                                                        minHeight: "40px",
                                                        boxShadow: "none",

                                                        // borderRadius: "23px",
                                                        background: "var(--main-color) 0% 0% no-repeat padding-box",
                                                        "&:hover": {
                                                            backgroundColor: "var(--main-color)",
                                                        },
                                                    }}
                                                >
                                                    {projectEditData ? "Update" : "Submit"}
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    // type="submit"
                                                    onClick={() => {
                                                        resetForm()
                                                        onClose()

                                                    }}
                                                    // sx={{ textTransform: "none", background: "#C38F51", color: "white", borderRadius: "23px" }}
                                                    sx={{
                                                        // backgroundColor: "#C38F51",
                                                        textTransform: "none",
                                                        color: "black",
                                                        fontSize: "16px",
                                                        // padding: "0px 40px",
                                                        padding: { xs: "0px 20px", md: "0px 40px" },

                                                        minHeight: "40px",
                                                        // boxShadow: 2,
                                                        // border:"1px solid gray",

                                                        // borderRadius: "23px",
                                                        background: "white 0% 0% no-repeat padding-box",
                                                        // "&:hover": {
                                                        //     backgroundColor: "#3B4056",
                                                        // },
                                                    }}
                                                >
                                                    Cancel
                                                </Button>
                                            </Grid>

                                        </Grid>
                                    </Form>
                                )}
                            </Formik>
                        </Box>
                    </Grid>
                </DialogContent>
                <ToastContainer
                    position="top-right"
                    autoClose={1500}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="dark"
                />


            </Box>
        </Dialog >
    );
};

export default ProjectsCreateModal;
